var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.254,
    height: 14.1,
    viewBox: "0 0 19.254 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Unione_10",
    "data-name": "Unione 10",
    d: "M17368.561-8394.308l-5.16-5.156a1.378,1.378,0,0,1-.4-.973,1.378,1.378,0,0,1,.4-.973,1.385,1.385,0,0,1,.973-.4,1.374,1.374,0,0,1,.973.4l4.188,4.188,10.375-10.378a1.381,1.381,0,0,1,.973-.4,1.385,1.385,0,0,1,.973.4,1.378,1.378,0,0,1,.4.973,1.372,1.372,0,0,1-.4.974l-11.352,11.346a1.35,1.35,0,0,1-.969.406A1.362,1.362,0,0,1,17368.561-8394.308Zm.973-.1Z",
    transform: "translate(-17363 8408.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.8705d59f9492b5611e74bfd2c2fccbad.svg";
export { ForwardRef as ReactComponent };